import { Image, Btn, H6, H5 } from '../../../../AbstractElements';
import { CreditCard } from '../../../../Constant';
import card from '../../../../assets/images/ecommerce/card.png';
import { Card, CardBody, Col, Form, FormGroup, Input, Row } from 'reactstrap';
import React, { Fragment, useState } from 'react';
import HeaderCard from '../../../Common/Component/HeaderCard';
import { Link, useNavigate } from 'react-router-dom';
import FormModal from '../../../UiKits/Modals/VaryingContent/common/FormModal';

const CreditCards = (props) => {
	
  const [modal, setModal] = useState(false); 
  const toggle = () => setModal(!modal);
  //alert(JSON.stringify(props));
  const history = useNavigate();

  //alert(JSON.stringify(props.userDetails));
  
  function editApplication(){ 

    localStorage.setItem('supervisor_edit_application',JSON.stringify(props.userDetails));
    history(`${process.env.PUBLIC_URL}/dpsm/scheme/application/ltp/edit`);
    
  }

  let my_title='';
  let popup_review_title='';
  let eng='';

  

  if(props.userDetails!==null){
    
    

  if(props.userDetails.application_status!=undefined&&props.userDetails.application_status!=null&&props.userDetails.application_status=="Withdrawn"){
    popup_review_title="Application has been Withdrawn";
    my_title="Application has been Withdrawn";//alert('hero-- '+JSON.stringify(props.userDetails.application_status));
    eng="withdrawn_applications";
  }
  else if(props.userDetails.application_status!=undefined&&props.userDetails.application_status!=null&&props.userDetails.application_status=="Rejected"){
    popup_review_title="Application has been Rejected by the Evaluation Board";
    my_title="Application has been Rejected by the Evaluation Board";
    eng="rejected_candidates";

  }
  else if(props.userDetails.application_status!=undefined&&props.userDetails.application_status!=null&&props.userDetails.application_status=="Approved"){
    popup_review_title="Application has been Approved by the Evaluation Board";
    my_title="Application has been Approved by the Evaluation Board";
    eng="approved_candidates";
  }
  else {

    props.isPsApprover? popup_review_title='Application Review: (By Accounting Officer)':popup_review_title=' Application Review';
  props.approverType=="applicant"? my_title=' Preview Your Application':(props.isPsApprover? my_title=' Review Application (By Accounting Officer)':my_title=' Review Application');
  eng="qualifying_candidates";
  
  }
//#d1e7dd - green #cfe2ff -blue style={{background:"#e2e3e5", backgroundColor:"#e2e3e5"}}
}

  return (
    <Fragment>
      <Col xxl='8' className='box-col-12' >
        <Card className='height-equal credit-form card' >
          <HeaderCard title={my_title} eng={eng} />
          <CardBody>
            <Row>
              <Col md='14'>
			  
              {props.userDetails!==null? ( <Row>
                    <Col md='14'>
        <div style={{paddingLeft:'150px'}}><H6 >{"APPLICANT DETAILS"}</H6></div>
        <H5 >
			  <p><H6 >{"Name: "}<span className='f-light'>{props.userDetails.firstname}</span></H6></p>
			  <p><H6 >{"Surname: "}<span className='f-light'>{props.userDetails.surname}</span></H6></p>
			  <p><H6 >{"ID Number: "}<span className='f-light'>{props.userDetails.national_id}</span></H6></p>
			  <p><H6 >{"Ministry/Independent Department: "}<span className='f-light'>{props.userDetails.ministry}</span></H6></p>
			  <p><H6 >{"Home Phone: "}<span className='f-light'>{props.userDetails.home_phone}</span></H6></p>
			  <p><H6 >{"Cellphone Number: "}<span className='f-light'>{props.userDetails.cellphone_number}</span></H6></p>
			  <p><H6 >{"Email Address: "}<span className='f-light'>{props.userDetails.email_address}</span></H6></p>
			  <p><H6 >{"Postal Address: "}<span className='f-light'>{props.userDetails.postal_address}</span></H6></p>
			  <p><H6 >{"Duty Station: "}<span className='f-light'>{props.userDetails.town}</span></H6></p>
			  <p><H6 >{"Position: "}<span className='f-light'>{props.userDetails.job_title}</span></H6></p>
			  <p><H6 >{"Date of Birth : "}<span className='f-light'>{props.userDetails.birth_date}</span></H6></p>
			  <p><H6 >{"Gender: "}<span className='f-light'>{props.userDetails.gender}</span></H6></p>
			  <p><H6 >{"Salary Scale: "}<span className='f-light'>{props.userDetails.salary_scale}</span></H6></p>
			  <p><H6 >{"Employment Terms: "}<span className='f-light'>{props.userDetails.employment_type}</span></H6></p>			  
			  <p><H6 >{"Date of Joining Public Service : "}<span className='f-light'>{props.userDetails.employment_date}</span></H6></p>
			  <p>{" ."}</p></H5>
			
			 <div style={{paddingLeft:'150px'}}><H6 >{"APPLICANT SUBMISSION"}</H6></div>
			 
			  {props.approverType=="applicant"?(<H5 ><p><H6 >{"Type of Activity: "}</H6><span className='f-light'>{props.userDetails.business_activity_group}</span></p>
			  <p><H6 >{"Category: "}</H6><span className='f-light'>{props.userDetails.business_activity_sub_type}</span></p></H5>):
        (<H5 ><p><H6 >{"Type of Activity: "}</H6><span className='f-light'>{props.userDetails.intended_activity}</span></p>
			  <p><H6 >{"Category: "}</H6><span className='f-light'>{props.userDetails.activity_type}</span></p></H5>)}
			 <H5 >
			  {props.approverType=='general_approver'||props.approverType=='committee_approver'? (<p>{" Applicant Score:"}<span className='f-light'>{props.userDetails.applicant_score+"%"}</span></p>):null}
        
			  <p><H6 >{"Personal Motivation: "}</H6><span className='f-light'>{props.userDetails.personal_statement}</span></p>
        <p><H6 >{"Is Prepopulated Information Correct?: "}</H6><span className='f-light'>{props.userDetails.prepopulated_data_feedback}</span></p>
        </H5>  
        </Col>
            </Row>) : null}     
                  <Row>
                    <Col md='14'>
                      <div className='text-end'>
					  <p>{" ."}</p>
					  
					  				  
            {props.userDetails!==null? (props.isApplicationEvaluated || (props.isApplicationOwner!=undefined&&props.isApplicationOwner) || (props.userDetails.application_status!==null&&props.userDetails.application_status=="Withdrawn")? null: (props.isApprovingStageSupervisor && <Btn attrBtn={{ color: 'primary', className: 'me-3' , onClick: toggle}}>{"Review Application"}</Btn>)):null}						 
                 {props.userDetails!==null? ( <FormModal isChairSecretary={props.isChairSecretary} isApprovingStageSupervisor={props.isApprovingStageSupervisor} userDetails={props.userDetails} approverType={props.approverType} scheme_application_id={props.userDetails.scheme_application_id} modal={modal} NewMessage={popup_review_title} toggle={toggle} defaultVal={"Submit Endorsement"} PSorOther={props.isPsApprover} closeBtnTxt={"Back"} saveBtnTxt={props.saveBtnTxt} rejectBtnTxt={props.rejectBtnTxt} />
                 ):null}
					  
                 {props.isApprovingStageSupervisor && props.userDetails.stage==1 &&!props.isApplicationOwner? ( <Btn attrBtn={{ color: 'secondary', className: 'me-3' , onClick: editApplication}}>{"Edit Application"}</Btn>
                 ):null}	      
                       {/*} <Link to={`${process.env.PUBLIC_URL}/dpsm/scheme/ltp`}></Link>
                          <Btn attrBtn={{ color: 'danger' }}>{"Reject"}</Btn>*/}
                        
						{ /*<FormModal modal={modal} NewMessage={"Are you sure you are rejecting this application?"} toggle={toggle} defaultVal={"Yes"} PSorOther={false} closeBtnTxt={"Cancel"} saveBtnTxt={"Yes"} />
						*/}
                      </div> 
                    </Col>
                  </Row>
               
				
				
              </Col>
              
            </Row>
          </CardBody>
        </Card>
      </Col>
    </Fragment>
  );
};
export default CreditCards;
